import { Box, Grid, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

interface IFieldSet {
	children: ReactNode;
	title: string;
}

export const FieldSet: FC<IFieldSet> = ({ children, title }) => {
	return (
		<Box
			component='fieldset'
			sx={{
				padding: 0,
				margin: 0,
				border: 0,
				mt: 2,
				pb: 2,
			}}
		>
			<Box sx={{ paddingRight: { md: '20%' } }}>
				<Grid
					container
					sx={{
						textAlign: { xs: 'left', md: 'right' },
					}}
				>
					<Grid size={{ xs: 12, md: 4 }}>
						<Typography
							component='legend'
							sx={{
								mb: 1,
								fontSize: 20,
								fontWeight: 'bold',
							}}
						>
							{title}
						</Typography>
					</Grid>
				</Grid>
			</Box>
			{children}
		</Box>
	);
};

export default {};
